import { render, staticRenderFns } from "./SalesItem.vue?vue&type=template&id=258fedf0&scoped=true"
import script from "./SalesItem.vue?vue&type=script&lang=js"
export * from "./SalesItem.vue?vue&type=script&lang=js"
import style0 from "./SalesItem.vue?vue&type=style&index=0&id=258fedf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258fedf0",
  null
  
)

export default component.exports